import React from "react";
import { NavLink } from "react-router-dom";
import './ContactUs.scss'

export default class ContactUsLink extends React.PureComponent {
  render(): React.ReactNode {
    return (
      <>
        <NavLink to={'/About?statusPage=2'}>
          <div className="contact-us-label">
            <i className="mdi mdi-headset"></i>
          </div>
        </NavLink>
      </>
    );
  }
}
